import type { Component } from "svelte";
import { AuthenticationModalKind } from "@core/schema/AuthenticationModalKind.js";
import ConfirmSignUp from "./ConfirmSignUp.svelte";
import ForgotPassword from "./ForgotPassword.svelte";
import PasswordReset from "./PasswordReset.svelte";
import ResendConfirmationCode from "./ResendConfirmationCode.svelte";
import SignIn from "./SignIn.svelte";
import SignUp from "./SignUp.svelte";
import SignUpSuccess from "./SignUpSuccess.svelte";

export const authenticationModalComponentMap = {
	[AuthenticationModalKind.SignIn]: SignIn,
	[AuthenticationModalKind.ConfirmSignUp]: ConfirmSignUp,
	[AuthenticationModalKind.ForgotPassword]: ForgotPassword,
	[AuthenticationModalKind.PasswordReset]: PasswordReset,
	[AuthenticationModalKind.Register]: SignUp,
	[AuthenticationModalKind.RegisterSuccess]: SignUpSuccess,
	[AuthenticationModalKind.ResendConfirmationCode]: ResendConfirmationCode,
} satisfies Record<AuthenticationModalKind, Component<never>>;
